import { clsx } from 'clsx';

interface Props {
  label: string;
  value: string | number;
  sub?: string;
  trend?: { value: number; positive?: boolean };
  className?: string;
}

export function StatCard({ label, value, sub, trend, className }: Props) {
  return (
    <div className={clsx('card', className)}>
      <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">{label}</p>
      <p className="mt-1 text-2xl font-mono font-medium text-navy">{value}</p>
      {sub && <p className="mt-0.5 text-sm text-gray-500">{sub}</p>}
      {trend !== undefined && (
        <p className={clsx('mt-1 text-xs font-medium', trend.value >= 0 ? 'text-green-600' : 'text-red-600')}>
          {trend.value >= 0 ? '↑' : '↓'} {Math.abs(trend.value).toFixed(1)}% vs prior week
        </p>
      )}
    </div>
  );
}
